import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  canActivate() {
    let data = JSON.parse(localStorage.getItem('data'));
    if(Object.keys(data).length > 0){
      return true;
    }else{
      return false;
    }
  }
  
}
